import { Component, NgZone, OnInit, EventEmitter, Output, Input, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import * as moment from 'moment-timezone';
import * as $ from 'jquery';
import { CommonModule } from '@angular/common';
import { countries } from '../../../model/country-data-store';
import { HttpService } from '../../../service/http.service';
import { GlobalService } from '../../../service/global.service';

declare var bootstrap: any;
@Component({
  selector: 'app-product-checkout',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule],
  templateUrl: './product-checkout.component.html',
  styleUrl: './product-checkout.component.css'
})
export class ProductCheckoutComponent implements OnInit {

  @Output() close = new EventEmitter<boolean>();
  @Output() success = new EventEmitter<boolean>();
  @Input() productDetails: any;

  public countries: any = countries

  date: string | undefined;
  status: any;
  pujaData: any;
  astrologerData: any;
  userId: any;
  pujaOrderForm: FormGroup;
  reCaptchaVerifier!: any;
  showLoginPopup: boolean = false;
  optsent: boolean = false;
  isUserLoggedIn!: any;
  user_login_status: any;
  is_mobile_verified: boolean = false;
  loginText = "Login";
  loginAction: boolean = true;
  timeZone = moment.tz.guess();
  totalWalletAmount: any;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.India];
  verify: any;
  loginCheck: any;
  userLogin: FormGroup;
  userSignupForm: FormGroup;
  formDetails: any;
  constructor(private _homeService: HttpService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private hidemodel: NgbModal,
    private gS: GlobalService
  ) {

    this.pujaOrderForm = this.formBuilder.group({
      customerName: new UntypedFormControl(""),
      customerEmail: new UntypedFormControl("",),
      customerMobile: new UntypedFormControl(""),
      birtDate: new UntypedFormControl("",),
      birthTime: new UntypedFormControl("",),
      address: new UntypedFormControl("",),
      gender: new UntypedFormControl("",),
      birthPlace: new UntypedFormControl("",),
      comments: new UntypedFormControl(""),
      assessmentYear: new UntypedFormControl(""),
      panCardNumber: new UntypedFormControl(""),
      incomeTaxId: new UntypedFormControl(""),
    });
    this.date = '';
    this.pujaData = localStorage.getItem("ap-astro-puja-detail");
    this.pujaData = JSON.parse(this.pujaData);
    this.userId = this.gS.userData?.id;
  }



  ngOnInit(): void {
    ;
    this.getProductForm();
    this.userLogin = this.formBuilder.group({
      mobile: new UntypedFormControl(null, Validators.required),
      enterotp: new UntypedFormControl()
    });

    this.userSignupForm = this.formBuilder.group({
      name: new UntypedFormControl(null, Validators.required),
      email: new UntypedFormControl(null, Validators.required),
      mobile1: new UntypedFormControl(null, Validators.required),
      signupOtp: new UntypedFormControl()
    });
    this.verify = JSON.parse(localStorage.getItem('verificationId') || '{}');
    this.isUserLoggedIn = localStorage.getItem("user_login");
    this.isUserLoggedIn = JSON.parse(this.isUserLoggedIn);
    this.user_login_status = false;
    localStorage.setItem('timeZone', this.timeZone);
    if (localStorage.getItem("user_login_status") != null) {
      this.user_login_status = localStorage.getItem("user_login_status");
      localStorage.setItem('user_wallet_balance', "0");
      this.getUserWalletAmount();
    } else {

    }
  }

  // ngAfterViewInit(): void {
  //   const target = document.getElementById('pujaCheckOut');
  //   if (!target) {
  //     return;
  //   }
  //   document
  //     .querySelectorAll('.offcanvas-backdrop')
  //     .forEach((item: any) => item.remove());
  //   const existing = bootstrap.Offcanvas.getInstance(target);

  //   if (existing) {
  //     existing.dispose();
  //   }
  //   this.offcanvasInstance = new bootstrap.Offcanvas(target, {
  //     backdrop: false,
  //     keyboard: true,
  //     scroll: true
  //   });
  //   this.offcanvasInstance.show();
  // }


  getProductForm() {
    this._homeService.getProductForm(this.productDetails?.productTypeId).subscribe((data: any) => {
      if (data?.data) {
        this.formDetails = data?.data;
        this.setupValidators();
      }
    }, (error) => {
      console.log(error);
    });
  }

  /** Copy the entered PAN number into the Income Tax portal Id field (they're usually the same). */
  useSameAsPan() {
    const pan = (this.pujaOrderForm.get('panCardNumber')?.value || '').toString().trim().toUpperCase();
    if (!pan) { return; }
    const ctrl = this.pujaOrderForm.get('incomeTaxId');
    ctrl?.setValue(pan);
    ctrl?.markAsTouched();
    ctrl?.updateValueAndValidity();
  }

  /**
   * Apply validators only to the fields the product actually asks for.
   * Fields are rendered conditionally from formDetails, so validation must
   * mirror that — otherwise hidden, empty controls would block submit.
   */
  setupValidators() {
    const f = this.formDetails || {};

    // map: formDetails flag -> [controlName, extra validators]
    const rules: { flag: any; control: string; validators: any[] }[] = [
      { flag: f.name, control: 'customerName', validators: [Validators.required, Validators.minLength(2)] },
      { flag: f.email, control: 'customerEmail', validators: [Validators.required, Validators.email] },
      // mobile & gender fields are removed from the form — not needed for filing
      { flag: f.address, control: 'address', validators: [Validators.required, Validators.minLength(5)] },
      { flag: f.assessmentYear, control: 'assessmentYear', validators: [Validators.required] },
      {
        flag: f.panCardNumber, control: 'panCardNumber',
        validators: [Validators.required, Validators.pattern(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/)]
      },
      { flag: f.incomeTaxId, control: 'incomeTaxId', validators: [Validators.required] },
      { flag: f.dob, control: 'birtDate', validators: [Validators.required] },
      { flag: f.timeofbirth, control: 'birthTime', validators: [Validators.required] },
      { flag: f.placeOfBirth, control: 'birthPlace', validators: [Validators.required] },
    ];

    rules.forEach(({ flag, control, validators }) => {
      const ctrl = this.pujaOrderForm.get(control);
      if (!ctrl) { return; }
      ctrl.setValidators(flag ? validators : null);
      ctrl.updateValueAndValidity();
    });
  }

  /*--------Click Action for logout---------*/
  logoutUser() {
    localStorage.removeItem('user_login');
    localStorage.removeItem('user_login_status');
    this.user_login_status = false;
  }
  /*---------------End of Logout action----*/


  openLoginPopup() {
    this.showLoginPopup = true;
    console.log(this.showLoginPopup);
  }

  // Get user amount wallet
  getUserWalletAmount() {
    this._homeService.getUserWalletAmount(this.gS.customerId, 0).subscribe((data) => {
      let value: any = data;
      this.totalWalletAmount = value.availableBalance;
      localStorage.setItem('user_wallet_balance', value.availableBalance);
      console.log(this.totalWalletAmount);
    }, (error) => {
      console.log(error);
    });
  }

  onSubmit(): void {
    // productId: this.pujaData.id,
    // productPrice: this.pujaData?.productPrice,
    if (this.pujaOrderForm.invalid) {
      this.pujaOrderForm.markAllAsTouched();
      this.toastr.error("Please fill all required fields correctly", "Missing details");
      return;
    }
    if (this.pujaOrderForm.valid) {
      // Fall back to the @Input product if the localStorage copy is missing,
      // otherwise this line throws and the booking silently never advances.
      this.pujaOrderForm.value.productId = this.pujaData?.id ?? this.productDetails?.id;

      this.pujaOrderForm.value.userId = this.userId;
      this.pujaOrderForm.value.zoneType = localStorage.getItem("timeZone");

      console.log(this.pujaOrderForm.value);
      // return;
      this._homeService.submitPujaOrderForm(this.pujaOrderForm.value).subscribe((data) => {
        this.status = data;
        this.status = this.status;
        if (this.status.status == "success") {
          localStorage.setItem("puja-order-form-id", this.status.data.orderId);
          // this.router.navigate(['/astroapp-palm-order-payment-confirmation']);
          // this.palmOrderForm.reset();
          this.success.emit(true);

        } else {
          this.toastr.error("Something went wrong, please try again", "Failed to login");
        }
      }, (error) => {
        this.toastr.error("Something went wrong, please try again", "Failed to login");
        console.log(error);
      });
    }
  }

  handleOffcanvasClose() {
    document.body.style.overflow = '';
    this.close.emit(true);
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }


}
